import { defineComponent as _defineComponent } from 'vue';
import ToggleButton from 'primevue/togglebutton';
import InputText from 'primevue/inputtext';
import Button from 'primevue/button';
import { onMounted, ref } from 'vue';
import { useForm } from '@inertiajs/inertia-vue3';
import { required, minLength, sameAs } from '@vuelidate/validators';
import { useSpinner } from '../../Plugins/spinner';
import useVuelidate from '@vuelidate/core';
// import CompanyUserService from '../../Services/CompanyUserService';
export default /*#__PURE__*/ _defineComponent({
    __name: 'UserDetails',
    setup(__props, { expose }) {
        expose();
        const spinner = useSpinner();
        const value = ref({});
        const form = useForm({
            enabled: value.value.enabled ?? true,
            firstname: value.value.firstname,
            lastname: value.value.lastname,
            email: value.value.email,
            password: '',
            password_confirmation: '',
        });
        const rules = {
            enabled: { required },
            firstname: { required },
            lastname: { required },
            email: { required },
            password: { required, minLength: minLength(6) },
            password_confirmation: { required, sameAsPassword: sameAs('password') },
        };
        const v$ = useVuelidate(rules, form);
        const submitted = ref(false);
        const submit = async () => {
            submitted.value = true;
            const isFormValid = await v$.value.$validate();
            if (!isFormValid) {
                return;
            }
            spinner.show();
            // if (value.value.id) {
            //   CompanyUserService.store(value.value.id, form.data())
            //     .then(result => {
            //       emit('saved', result.data.data);
            //     })
            //     .finally(() => spinner.hide());
            // } else {
            //   CompanyService.store(form.data())
            //     .then(result => {
            //       emit('saved', result.data.data);
            //     })
            //     .finally(() => spinner.hide());
            // }
        };
        const __returned__ = { spinner, value, form, rules, v$, submitted, submit, get ToggleButton() { return ToggleButton; }, get InputText() { return InputText; }, get Button() { return Button; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
